{
  "common.yes": {
    "text": "Ya",
    "sourceHash": "b3a43630",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "common.no": {
    "text": "Tidak",
    "sourceHash": "61e6be1a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "common.related": {
    "text": "BERKAITAN",
    "sourceHash": "6faf59d8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "common.relatedNav": {
    "text": "Halaman berkaitan",
    "sourceHash": "6dc7db40",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "common.breadcrumb": {
    "text": "Jejak halaman",
    "sourceHash": "30635f6c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "common.home": {
    "text": "UTAMA",
    "sourceHash": "10b8c84e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "cite.title": {
    "text": "Sumber: {{label}} (disemak {{date}})",
    "sourceHash": "01792346",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.home.title": {
    "text": "Keperluan GST InvoiceNow Singapura (IRAS): Panduan & Senarai Semak",
    "sourceHash": "5f393811",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.home.description": {
    "text": "Panduan mudah tentang GST InvoiceNow Requirement Singapura: senarai semak lima langkah, tarikh penting, perisian percuma dan geran, semuanya bersumberkan IRAS dan IMDA.",
    "sourceHash": "2e5f836d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.home.crumb": {
    "text": "Utama",
    "sourceHash": "52f50eae",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.home.llms": {
    "text": "Apa itu InvoiceNow, faedahnya, senarai semak lima langkah, acara IRAS akan datang dan tempat bertanya soalan.",
    "sourceHash": "bb1cdd91",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.setup.title": {
    "text": "Cara Menyediakan GST InvoiceNow di Singapura: 5 Langkah",
    "sourceHash": "4bfb45a3",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.setup.description": {
    "text": "Langkah demi langkah menyediakan InvoiceNow untuk perniagaan berdaftar GST di Singapura: semak tarikh anda, pilih perisian InvoiceNow-Ready, dapatkan ID Peppol, hidupkan penghantaran kepada IRAS dan ujinya.",
    "sourceHash": "fdf14cc2",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.setup.crumb": {
    "text": "Panduan penyediaan",
    "sourceHash": "f3664512",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.setup.nav": {
    "text": "Penyediaan",
    "sourceHash": "0837a3d6",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.setup.llms": {
    "text": "Lima langkah untuk bersedia bagi Keperluan GST InvoiceNow, setiap satu dengan sumber rasminya, carian ID Peppol, dan tempat anda log masuk untuk menggunakan InvoiceNow.",
    "sourceHash": "1c626952",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.when.title": {
    "text": "Bila GST InvoiceNow Terpakai? Fasa dan Kalkulator Tarikh",
    "sourceHash": "09845b8b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.when.description": {
    "text": "Fasa GST InvoiceNow dari 1 Nov 2025 hingga 1 Apr 2031, serta kalkulator tarikh mengikut Soalan Lazim IRAS untuk bekalan, pendaftar baharu dan kumpulan GST.",
    "sourceHash": "e161b889",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.when.crumb": {
    "text": "Bila ia terpakai",
    "sourceHash": "f454ea0a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.when.nav": {
    "text": "Bila",
    "sourceHash": "021e3a39",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.when.llms": {
    "text": "Jadual pelaksanaan dan peraturan kalkulator tarikh (soalan lazim IRAS Q1.5 hingga Q1.12, Q7.2).",
    "sourceHash": "ca1ed4d8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.free-software.title": {
    "text": "Perisian GST InvoiceNow: Pakej Percuma, Penyedia, Geran",
    "sourceHash": "5fde6215",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.free-software.description": {
    "text": "Pakej InvoiceNow percuma, sama ada Xero, AutoCount, ABSS, SAP Business One, QuickBooks dan perisian lain ada dalam senarai InvoiceNow-Ready IMDA, dan cara mencari penyedia.",
    "sourceHash": "417bbf11",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.free-software.crumb": {
    "text": "Perisian dan geran",
    "sourceHash": "a862ba00",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.free-software.nav": {
    "text": "Perisian dan geran",
    "sourceHash": "a862ba00",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.free-software.llms": {
    "text": "Pakej percuma, perisian perakaunan popular yang ada dalam senarai InvoiceNow-Ready IMDA, senarai penyedia, dan alat bantu untuk memilih antara pakej percuma, IRSP dan Titik Akses.",
    "sourceHash": "0f1212a3",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.grants.title": {
    "text": "Geran InvoiceNow: Geran Peralihan S$1,000 dan S$5,000, Queen Bee",
    "sourceHash": "ad42ba17",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.grants.description": {
    "text": "Geran Peralihan GST InvoiceNow IMDA (S$1,000 dan S$5,000) dan Geran Queen Bee S$25,000: siapa yang layak, syarat, tarikh akhir dan borang tuntutan, setiap satu bersumberkan IMDA.",
    "sourceHash": "90531b62",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.grants.crumb": {
    "text": "Geran",
    "sourceHash": "8d86615a",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.grants.nav": {
    "text": "Geran",
    "sourceHash": "8d86615a",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.grants.llms": {
    "text": "Geran Peralihan GST InvoiceNow S$1,000 dan S$5,000, Geran Queen Bee S$25,000 dan Geran Penyelesaian Produktiviti: kelayakan, syarat, tempoh dan borang tuntutan.",
    "sourceHash": "0baa9ee6",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.how-it-works.title": {
    "text": "Cara GST InvoiceNow Berfungsi: Jenis Penghantaran dan Peppol ID",
    "sourceHash": "0e07a929",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.how-it-works.description": {
    "text": "Cara invois bergerak di InvoiceNow dan sampai ke IRAS (Type 1A, 1B, 2 dan 3), apa itu Peppol ID, IRSP dan Access Point, serta semakan Peppol ID.",
    "sourceHash": "67b0d3a4",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.how-it-works.crumb": {
    "text": "Cara ia berfungsi",
    "sourceHash": "d03ba450",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.how-it-works.nav": {
    "text": "Cara ia berfungsi",
    "sourceHash": "d03ba450",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.how-it-works.llms": {
    "text": "Jenis penghantaran beranimasi, apa yang anda perlukan (Peppol ID, IRSP atau Access Point) dan semakan Peppol ID.",
    "sourceHash": "2dbc2e54",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.pos-and-retail.title": {
    "text": "GST InvoiceNow untuk POS dan Runcit: Data Jualan dan Resit",
    "sourceHash": "e7b4858b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.pos-and-retail.description": {
    "text": "Maksud GST InvoiceNow Requirement jika anda menjual melalui POS atau mesin tunai: resit, jualan agregat, pelanggan bukan di InvoiceNow, dan tarikh akhir.",
    "sourceHash": "3d8df85c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.pos-and-retail.crumb": {
    "text": "POS dan runcit",
    "sourceHash": "a1bea913",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.pos-and-retail.nav": {
    "text": "POS & runcit",
    "sourceHash": "343b7552",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.pos-and-retail.llms": {
    "text": "POS dan jualan agregat (soalan lazim IRAS Q3.4, Q3.12), pelanggan yang tiada dalam InvoiceNow, tarikh akhir dan ID pengakuan.",
    "sourceHash": "18167dca",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.faq.title": {
    "text": "Soalan Lazim GST InvoiceNow: Jawapan Bersumberkan IRAS",
    "sourceHash": "5ad6879b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.faq.description": {
    "text": "Jawapan ringkas tentang GST InvoiceNow Requirement Singapura, setiap ayat dipautkan ke soalan Soalan Lazim IRAS atau perenggan e-Tax Guide yang menjadi sumbernya.",
    "sourceHash": "648fd67d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.faq.crumb": {
    "text": "Soalan lazim",
    "sourceHash": "3ed2943b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.faq.nav": {
    "text": "Soalan lazim",
    "sourceHash": "3ed2943b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.faq.llms": {
    "text": "Setiap jawapan soalan lazim, dengan sumber untuk setiap ayat.",
    "sourceHash": "aac2b357",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.links.title": {
    "text": "Pautan GST InvoiceNow: IRAS, IMDA, Geran, Senarai Penyedia",
    "sourceHash": "c174fb14",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.links.description": {
    "text": "Semua pautan rasmi GST InvoiceNow di satu tempat: e-Tax Guide dan Soalan Lazim IRAS, geran IMDA, serta senarai penyedia penyelesaian dan Access Point, setiap satu dijelaskan.",
    "sourceHash": "34db9b6c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.links.crumb": {
    "text": "Pautan berguna",
    "sourceHash": "237d6316",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.links.nav": {
    "text": "Pautan",
    "sourceHash": "9202088e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.links.llms": {
    "text": "Semua pautan rasmi IRAS dan IMDA, setiap satu diterangkan.",
    "sourceHash": "508112b9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.about.title": {
    "text": "Tentang InvoiceNow Hub: Bebas, Tidak Rasmi, Bersumber",
    "sourceHash": "50517565",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.about.description": {
    "text": "Siapa yang mengendalikan InvoiceNow Hub, mengapa ia wujud, bagaimana setiap fakta disemak berbanding sumber IRAS dan IMDA, dan data apa yang disimpan oleh laman ini.",
    "sourceHash": "3ad6f2bf",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.about.crumb": {
    "text": "Tentang",
    "sourceHash": "58e096de",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.about.llms": {
    "text": "Siapa yang mengendalikan laman ini, bagaimana fakta disemak, dan privasi.",
    "sourceHash": "90448af6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.changelog.title": {
    "text": "Log Perubahan InvoiceNow Hub: Perubahan Kandungan Mengikut Tarikh",
    "sourceHash": "bab8730a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.changelog.description": {
    "text": "Rekod awam bertarikh bagi setiap perubahan kandungan InvoiceNow Hub, termasuk pembetulan yang dibuat selepas menyemak sumber IRAS dan IMDA.",
    "sourceHash": "346f4996",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.changelog.crumb": {
    "text": "Log perubahan",
    "sourceHash": "b3dc8779",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.changelog.llms": {
    "text": "Senarai perubahan kandungan mengikut tarikh.",
    "sourceHash": "ff009ee8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.notfound.title": {
    "text": "Halaman tidak ditemui · InvoiceNow Hub",
    "sourceHash": "2e79a110",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.notfound.description": {
    "text": "Tiada halaman di alamat ini.",
    "sourceHash": "a05926c8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "banner.aria": {
    "text": "Tentang laman ini",
    "sourceHash": "5c9321fd",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "banner.text": {
    "text": "<b>Panduan bebas.</b> Tidak bergabung dengan IRAS (pihak berkuasa cukai Singapura) atau IMDA (pihak berkuasa media infokom). Untuk kes anda sendiri, tanya <iras>IRAS</iras> atau <imda>IMDA</imda> secara terus.",
    "sourceHash": "dd7d33bf",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "banner.about": {
    "text": "Tentang laman ini",
    "sourceHash": "5c9321fd",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "i18n.unofficial": {
    "text": "<b>Terjemahan tidak rasmi.</b> Versi bahasa Inggeris yang terpakai.",
    "sourceHash": "b9879782",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "i18n.englishLink": {
    "text": "Baca halaman ini dalam bahasa Inggeris",
    "sourceHash": "f26f93a5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "i18n.draft": {
    "text": "Draf terjemahan, belum disemak oleh penutur asli. Jangan bergantung padanya.",
    "sourceHash": "e7c07fff",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "i18n.switcher": {
    "text": "Bahasa",
    "sourceHash": "9a73db9b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "i18n.current": {
    "text": "Bahasa semasa: {{language}}",
    "sourceHash": "1987a4ec",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "nav.main": {
    "text": "Utama",
    "sourceHash": "51707928",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "nav.footer": {
    "text": "Kaki halaman",
    "sourceHash": "575cffd2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "nav.whatToDo": {
    "text": "Apa yang patut saya buat?",
    "sourceHash": "0df3ccb7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "nav.whatToDoShort": {
    "text": "Apa perlu dibuat",
    "sourceHash": "cf2e345d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "nav.question": {
    "text": "Saya ada soalan",
    "sourceHash": "537be29b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "nav.openMenu": {
    "text": "Buka menu",
    "sourceHash": "b79c01dc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "nav.closeMenu": {
    "text": "Tutup menu",
    "sourceHash": "58ee52ce",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "nav.overview": {
    "text": "Gambaran",
    "sourceHash": "6a494fba",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "nav.privacy": {
    "text": "Privasi",
    "sourceHash": "ebfa87e7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "footer.disclaimer": {
    "text": "Hab maklumat bebas, tidak bergabung dengan IRAS atau IMDA. Setiap fakta dipautkan kepada dokumen IRAS atau IMDA yang menjadi sumbernya; kali terakhir disemak berbanding sumber itu pada {{date}}. Sentiasa sahkan dengan sumber rasmi, dan bawa soalan tentang kes anda sendiri kepada <iras>IRAS</iras> atau <imda>IMDA</imda>.",
    "sourceHash": "89524644",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "footer.made": {
    "text": "DIBUAT DENGAN <heart>♥</heart> DI SINGAPURA",
    "sourceHash": "8fb48457",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "footer.love": {
    "text": "kasih",
    "sourceHash": "d52792d1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "footer.updated": {
    "text": "KEMAS KINI TERAKHIR {{date}}",
    "sourceHash": "ef1dfe86",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "welcome.loading": {
    "text": "Memuatkan InvoiceNow Hub",
    "sourceHash": "e69aca57",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "welcome.top": {
    "text": "PANDUAN BEBAS",
    "sourceHash": "9f78118d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "welcome.place": {
    "text": "SINGAPURA · {{year}}",
    "sourceHash": "94ed3b21",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "welcome.tagline": {
    "text": "GST INVOICENOW REQUIREMENT, DI SATU TEMPAT",
    "sourceHash": "0dc4b2b9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "hero.srTitle": {
    "text": "InvoiceNow: GST InvoiceNow Requirement untuk perniagaan Singapura, di satu tempat",
    "sourceHash": "17bc1a98",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "hero.fig1": {
    "text": "RAJAH 01 — PERNIAGAAN SINGAPURA MENGHANTAR E-INVOIS TERUS KEPADA SATU SAMA LAIN",
    "sourceHash": "f160cfda",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "hero.fig2": {
    "text": "RAJAH 02 — E-INVOIS MENGHUBUNGKAN SINGAPURA DENGAN RANTAU INI DAN DUNIA",
    "sourceHash": "5cb25fb0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "hero.einvoice": {
    "text": "E-INVOIS",
    "sourceHash": "59faa2c6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "hero.inOnePlace": {
    "text": "di satu tempat",
    "sourceHash": "b01ebb29",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "hero.lead": {
    "text": "Apa itu GST InvoiceNow Requirement (keperluan e-invois GST), bila ia terpakai kepada perniagaan anda, dan apa yang perlu dibuat seterusnya.",
    "sourceHash": "54df4707",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "hero.lastVerified": {
    "text": "Kali terakhir disemak berbanding sumber rasmi: {{date}}",
    "sourceHash": "fd6c7239",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "hero.cta": {
    "text": "MULAKAN SENARAI SEMAK",
    "sourceHash": "f72c8cac",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "hero.mapAria": {
    "text": "Peta animasi: perniagaan di seluruh Singapura, setiap satu ditunjukkan dengan ikon jenis perniagaannya, menghantar e-invois kepada satu sama lain. Paparan kemudian melebar menjadi glob yang menunjukkan Singapura berhubung dengan Asia Pasifik.",
    "sourceHash": "4e099061",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.eyebrow": {
    "text": "01 — ASAS INVOICENOW 101",
    "sourceHash": "7f5a8d73",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.title": {
    "text": "InvoiceNow<br/><accent>101</accent>",
    "sourceHash": "30bd8b9a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.lead": {
    "text": "InvoiceNow ialah rangkaian e-invois kebangsaan Singapura. Mulakan di sini: apa itu, apa yang perlu dibuat dahulu, dan di mana mencari butirannya.",
    "sourceHash": "7c228434",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.today": {
    "text": "HARI INI",
    "sourceHash": "25b07d1e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.with": {
    "text": "DENGAN INVOICENOW",
    "sourceHash": "3ed59ed2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.node.supplier": {
    "text": "PEMBEKAL",
    "sourceHash": "82872649",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.node.pdf": {
    "text": "PDF",
    "sourceHash": "ae047875",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.node.email": {
    "text": "E-MEL",
    "sourceHash": "4086f1a7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.node.retype": {
    "text": "TAIP SEMULA",
    "sourceHash": "3ba5e258",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.node.customer": {
    "text": "PELANGGAN",
    "sourceHash": "d03c4dd9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.node.network": {
    "text": "RANGKAIAN",
    "sourceHash": "60b0d865",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.node.iras": {
    "text": "IRAS",
    "sourceHash": "7be84b1e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.todayBody": {
    "text": "Invois ialah salinan PDF atau kertas. Pelanggan membacanya dan menaip semula angka-angkanya ke dalam sistem mereka sendiri.",
    "sourceHash": "a82ec83b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.withBody": {
    "text": "Invois pergi terus dari perisian pembekal ke perisian pelanggan sebagai data berstruktur: tiada PDF, tiada taip semula. Bagi perniagaan berdaftar GST, salinan data invois juga dihantar kepada IRAS.",
    "sourceHash": "6785c176",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "explore.eyebrow": {
    "text": "CARI BUTIRAN",
    "sourceHash": "71c848a7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "explore.when.text": {
    "text": "Fasa dari 2025 hingga 2031, dan kalkulator tarikh yang mengikut soalan lazim IRAS.",
    "sourceHash": "56c8cb0b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "explore.free-software.text": {
    "text": "Pakej percuma IMDA, geran InvoiceNow, dan cara mencari penyedia.",
    "sourceHash": "a5249cb4",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "explore.how-it-works.text": {
    "text": "Bagaimana invois dan datanya bergerak, apa itu Peppol ID dan Access Point, dan langkah seterusnya.",
    "sourceHash": "4dd8b32d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "explore.pos-and-retail.text": {
    "text": "Resit, jualan agregat dan pelanggan yang tiada dalam InvoiceNow.",
    "sourceHash": "fb98cbca",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "explore.faq.text": {
    "text": "Jawapan ringkas, setiap ayat dipautkan kepada soalan dalam soalan lazim IRAS yang menjadi sumbernya.",
    "sourceHash": "f92a335e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "explore.links.text": {
    "text": "Semua pautan rasmi IRAS dan IMDA, setiap satu diterangkan.",
    "sourceHash": "508112b9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.start": {
    "text": "MULA DI SINI",
    "sourceHash": "3a69c0a3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.title": {
    "text": "Apa yang perlu dibuat sekarang",
    "sourceHash": "bd4b4b81",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.progress": {
    "text": "{{done}} DARIPADA {{total}} SELESAI",
    "sourceHash": "62cf8b88",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.reset": {
    "text": "SET SEMULA SENARAI SEMAK",
    "sourceHash": "5eb00d60",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.guide": {
    "text": "Panduan penuh langkah demi langkah",
    "sourceHash": "766641cd",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "setup.step": {
    "text": "LANGKAH {{n}} DARIPADA {{total}}",
    "sourceHash": "291696c8",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "setup.loginTitle": {
    "text": "Adakah InvoiceNow mempunyai log masuk?",
    "sourceHash": "6b0d8733",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "setup.loginLead": {
    "text": "Anda menggunakan InvoiceNow melalui Penyelesaian InvoiceNow-Ready anda, jadi anda log masuk ke perisian penyedia anda, dan di situlah penghantaran anda dipaparkan.",
    "sourceHash": "4bc71ba0",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "setup.trackerNote": {
    "text": "Mahu tandakan langkah semasa anda membuatnya?",
    "sourceHash": "bbe04031",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "setup.trackerLink": {
    "text": "Gunakan senarai semak di halaman utama",
    "sourceHash": "a5cd9529",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.nextStep": {
    "text": "LANGKAH SETERUSNYA · {{n}} DARIPADA {{total}}",
    "sourceHash": "2d90689f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.allDone": {
    "text": "SEMUA LANGKAH SELESAI 🎉",
    "sourceHash": "8400e0dc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.iDidThis": {
    "text": "Saya sudah buat",
    "sourceHash": "22606b5a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.pill.back": {
    "text": "Kembali ke senarai semak",
    "sourceHash": "3eb56e0b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.pill.done": {
    "text": "{{done}}/{{total}} SELESAI",
    "sourceHash": "f158d5f0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.pill.region": {
    "text": "Pintasan senarai semak",
    "sourceHash": "ae6fc30b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.pill.hide": {
    "text": "Sembunyikan pintasan senarai semak",
    "sourceHash": "ec623fcd",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.pill.show": {
    "text": "Tunjukkan pintasan senarai semak",
    "sourceHash": "157935ee",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.pill.showAria": {
    "text": "Tunjukkan pintasan senarai semak, {{done}} daripada {{total}} selesai",
    "sourceHash": "dfa0dd87",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.0.t": {
    "text": "Semak tarikh anda",
    "sourceHash": "5fa6b1aa",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.0.d": {
    "text": "Ketahui fasa anda.",
    "sourceHash": "98f79dae",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.0.title": {
    "text": "Ketahui tarikh anda",
    "sourceHash": "b817b897",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.0.body": {
    "text": "Gunakan kalkulator untuk melihat fasa anda. IRAS juga sepatutnya sudah memberitahu anda melalui MyTaxMail (peti mel dalam talian IRAS), jadi ikut surat itu.",
    "sourceHash": "58e56ece",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.0.a.0": {
    "text": "Buka kalkulator tarikh",
    "sourceHash": "c464a842",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.0.a.1": {
    "text": "Lihat jadual penuh",
    "sourceHash": "b380042b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.1.t": {
    "text": "Semak perisian anda",
    "sourceHash": "9f42728f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.1.d": {
    "text": "Adakah ia dalam senarai InvoiceNow-Ready IMDA? Belum ada perisian? Pilih satu.",
    "sourceHash": "6f91043c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.1.title": {
    "text": "Pastikan perisian anda InvoiceNow-Ready",
    "sourceHash": "34412348",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.1.body": {
    "text": "Cari perisian anda dalam senarai penyedia penyelesaian InvoiceNow-Ready (IRSP) IMDA. Jika anda menggunakan ERP atau sistem dalaman sendiri, anda perlukan penyedia Access Point (titik akses) yang ditauliahkan IMDA. Belum ada perisian? IMDA menyenaraikan pakej percuma.",
    "sourceHash": "752e3c18",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.1.a.0": {
    "text": "Senarai IRSP",
    "sourceHash": "c2af4eb3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.1.a.1": {
    "text": "Senarai Access Point",
    "sourceHash": "f269f97f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.1.a.2": {
    "text": "Saya tiada perisian InvoiceNow-Ready",
    "sourceHash": "fa95c4fe",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.1.a.3": {
    "text": "Guna sistem POS atau runcit?",
    "sourceHash": "02e235b8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.1.a.4": {
    "text": "Bantu saya memilih",
    "sourceHash": "7f98f8ed",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.2.t": {
    "text": "Dapatkan Peppol ID anda",
    "sourceHash": "c53fe87f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.2.d": {
    "text": "Hubungi penyedia IRSP atau Access Point anda.",
    "sourceHash": "2f4e24f3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.2.title": {
    "text": "Dapatkan Peppol ID anda",
    "sourceHash": "c53fe87f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.2.body": {
    "text": "Minta penyedia IRSP atau Access Point anda mendaftarkan perniagaan anda dalam SG Peppol Directory menggunakan UEN (nombor pengenalan entiti) anda. Cari di bawah untuk semak sama ada anda sudah ada satu.",
    "sourceHash": "9319d07f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.2.a.0": {
    "text": "Minta penyedia pakej percuma menelefon",
    "sourceHash": "8b5a108e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.2.a.1": {
    "text": "Apa yang anda perlukan untuk bermula",
    "sourceHash": "3857a84c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.3.t": {
    "text": "Hidupkan penghantaran GST InvoiceNow",
    "sourceHash": "235ac8d3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.3.d": {
    "text": "Hubungi penyedia IRSP atau Access Point anda.",
    "sourceHash": "2f4e24f3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.3.title": {
    "text": "Hidupkan penghantaran GST InvoiceNow",
    "sourceHash": "235ac8d3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.3.body": {
    "text": "Aktifkan ciri penghantaran GST InvoiceNow untuk mula menghantar data invois kepada IRAS. Penyedia IRSP atau Access Point anda boleh membantu.",
    "sourceHash": "e83f15f8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.3.a.0": {
    "text": "Cara penghantaran kepada IRAS berfungsi",
    "sourceHash": "a22b8b59",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.3.a.1": {
    "text": "Baca soalan lazim",
    "sourceHash": "7c14797e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.4.t": {
    "text": "Pastikan penghantaran berjaya",
    "sourceHash": "1c6ebe3f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.4.d": {
    "text": "Hantar invois ujian dan sahkan IRAS menerimanya.",
    "sourceHash": "90f2504f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.4.title": {
    "text": "Pastikan penghantaran berjaya",
    "sourceHash": "bfce8736",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.4.body": {
    "text": "Uji sebelum tarikh anda dan semak penyelesaian anda memaparkan ID pengakuan (acknowledgement ID) IRAS bagi setiap penghantaran yang berjaya. Untuk sistem dalaman, IRAS menyatakan anda perlu memperuntukkan {{from}} hingga {{to}} bulan untuk sambungan sistem.",
    "sourceHash": "38d01780",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.4.a.0": {
    "text": "Baca e-Tax Guide",
    "sourceHash": "e1863849",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.4.a.1": {
    "text": "Sertai webinar IRAS",
    "sourceHash": "4e35f0a1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.4.a.2": {
    "text": "Semua pautan berguna",
    "sourceHash": "7cd30ec6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.done.title": {
    "text": "Anda sudah bersedia untuk InvoiceNow",
    "sourceHash": "53a66a01",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.done.body": {
    "text": "Teruskan menghantar data invois melalui penyelesaian anda dan simpan rekod anda sekurang-kurangnya 5 tahun. Semak geran yang mungkin boleh anda tuntut, dan beritahu rakan dagang anda bahawa mereka boleh menghantar e-invois kepada anda.",
    "sourceHash": "ec58230d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.done.a.0": {
    "text": "Geran yang tersedia",
    "sourceHash": "56883285",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.done.a.1": {
    "text": "Acara akan datang",
    "sourceHash": "484376c0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.done.a.2": {
    "text": "Saya ada soalan",
    "sourceHash": "537be29b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "events.eyebrow": {
    "text": "02 — ACARA AKAN DATANG",
    "sourceHash": "05eca34c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "events.title": {
    "text": "Belajar <accent>secara langsung</accent>",
    "sourceHash": "56984197",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "events.signup": {
    "text": "Daftar",
    "sourceHash": "6a7d7331",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "events.details": {
    "text": "Butiran",
    "sourceHash": "0ec24245",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "events.none": {
    "text": "Tiada acara yang dibuka untuk pendaftaran sekarang. <lnk>Semak halaman acara IRAS</lnk>",
    "sourceHash": "896a0649",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "events.source": {
    "text": "Disenaraikan daripada <lnk>halaman acara IRAS</lnk>. Pendaftaran dibuka dan ditutup oleh IRAS, jadi semak halaman itu untuk maklumat terkini.",
    "sourceHash": "b3c0894c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "events.asOf": {
    "text": "Senarai acara setakat {{date}}.",
    "sourceHash": "41c4773a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "question.eyebrow": {
    "text": "03 — SAYA ADA SOALAN",
    "sourceHash": "7668c750",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "question.title": {
    "text": "Tanya <accent>pihak yang betul</accent>",
    "sourceHash": "29b27cc1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "question.lead": {
    "text": "Laman ini bebas dan tidak boleh memberi nasihat tentang keadaan anda. Untuk apa-apa tentang kes anda sendiri, gunakan borang hubungan rasmi IRAS dan IMDA di bawah.",
    "sourceHash": "a3135ddb",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "question.allLinks": {
    "text": "Lihat semua pautan berguna",
    "sourceHash": "f90ceca2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "question.faq": {
    "text": "Soalan lazim",
    "sourceHash": "97c33d95",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.setup.eyebrow": {
    "text": "PANDUAN PENYEDIAAN",
    "sourceHash": "31e53132",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.setup.title": {
    "text": "Sediakan InvoiceNow <accent>dalam lima langkah</accent>",
    "sourceHash": "97d06ea2",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.setup.intro": {
    "text": "Untuk bersedia bagi Keperluan GST InvoiceNow: ketahui tarikh pelaksanaan anda, semak sama ada perisian anda InvoiceNow-Ready (atau pilih pakej percuma), dapatkan ID Peppol melalui penyedia anda, hidupkan penghantaran GST InvoiceNow, dan pastikan IRAS mengakui data invois anda.",
    "sourceHash": "7c1162fc",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.when.eyebrow": {
    "text": "BILA IA TERPAKAI",
    "sourceHash": "ddfdfa4a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.when.title": {
    "text": "Bila GST InvoiceNow <accent>terpakai kepada anda</accent>",
    "sourceHash": "4fe55c11",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.when.intro": {
    "text": "GST InvoiceNow Requirement dilaksanakan secara berfasa dari 2025 hingga 2031. Cari fasa anda dalam jadual, atau jawab beberapa soalan dalam kalkulator. Ikut surat MyTaxMail daripada IRAS jika anda ada.",
    "sourceHash": "3b4b34a1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.free-software.eyebrow": {
    "text": "PERISIAN DAN GERAN",
    "sourceHash": "026adb00",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.free-software.title": {
    "text": "Perisian InvoiceNow <accent>dan geran</accent>",
    "sourceHash": "c3422fc6",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.free-software.intro": {
    "text": "IMDA menyenaraikan pakej InvoiceNow percuma untuk perniagaan berdaftar GST, dan menyediakan geran untuk langganan dan menyambungkan sistem anda sendiri.",
    "sourceHash": "c061b87b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.grants.eyebrow": {
    "text": "GERAN",
    "sourceHash": "e51cbffa",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.grants.title": {
    "text": "Geran <accent>InvoiceNow</accent>",
    "sourceHash": "07424232",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.grants.intro": {
    "text": "IMDA memberikan geran tunai untuk membantu perniagaan anda menyertai GST InvoiceNow: Geran Peralihan mengikut saiz perniagaan anda, dan geran yang lebih besar untuk menyambungkan ERP anda sendiri. Semak yang mana sesuai sebelum anda melanggan atau memulakan projek: syaratnya merangkumi bila anda mendaftar dan apa yang anda gunakan sebelum ini.",
    "sourceHash": "062d6627",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.how-it-works.eyebrow": {
    "text": "CARA IA BERFUNGSI",
    "sourceHash": "686e8db0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.how-it-works.title": {
    "text": "Cara GST InvoiceNow <accent>berfungsi</accent>",
    "sourceHash": "72d86e15",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.how-it-works.intro": {
    "text": "Bagaimana invois dan datanya bergerak dalam InvoiceNow, apa yang anda perlukan untuk menyertai, dan penyemak ringkas yang menunjukkan langkah seterusnya.",
    "sourceHash": "c8b6e0d7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.pos-and-retail.eyebrow": {
    "text": "POS DAN RUNCIT",
    "sourceHash": "69cfe073",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.pos-and-retail.title": {
    "text": "GST InvoiceNow untuk <accent>POS dan runcit</accent>",
    "sourceHash": "93ab4774",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.pos-and-retail.intro": {
    "text": "Jika anda menjual kepada orang ramai melalui sistem tempat jualan (POS) atau mesin daftar tunai, inilah bahagian keperluan yang paling penting untuk anda.",
    "sourceHash": "c861edd4",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.faq.eyebrow": {
    "text": "SOALAN LAZIM",
    "sourceHash": "3ed2943b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.faq.title": {
    "text": "Soalan lazim <accent>GST InvoiceNow</accent>",
    "sourceHash": "0a7f8a21",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.faq.intro": {
    "text": "Jawapan dalam bahasa mudah kepada soalan lazim tentang GST InvoiceNow Requirement, bersumber ayat demi ayat.",
    "sourceHash": "1fe05500",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "timeline.eyebrow": {
    "text": "JADUAL",
    "sourceHash": "bc44f6d6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "timeline.title": {
    "text": "Siapa menyertai, <accent>dan bila</accent>",
    "sourceHash": "9d560600",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "timeline.lead": {
    "text": "Berfasa dari 2025 hingga 2031. Jika anda sudah berdaftar GST, fasa anda bergantung pada jumlah bekalan tahunan anda.",
    "sourceHash": "28b2be96",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "timeline.inEffect": {
    "text": "● BERKUAT KUASA",
    "sourceHash": "5d7236da",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "timeline.next": {
    "text": "○ SETERUSNYA · {{until}}",
    "sourceHash": "1017e15a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "timeline.future": {
    "text": "○ {{until}}",
    "sourceHash": "21f6174a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "timeline.cta": {
    "text": "Semak tarikh pelaksanaan anda",
    "sourceHash": "17b63db8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "timeline.source": {
    "text": "Sumber: <lnk>{{label}}</lnk>. Ambang ialah jumlah bekalan tahunan dalam tempoh yang berakhir pada 2025.",
    "sourceHash": "b4b776f5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "until.inEffect": {
    "text": "BERKUAT KUASA",
    "sourceHash": "208f4e47",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "until.underMonth": {
    "text": "KURANG DARI SEBULAN LAGI",
    "sourceHash": "53c8f61a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "until.oneMonth": {
    "text": "1 BULAN LAGI",
    "sourceHash": "b8ad03cc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "until.months": {
    "text": "{{count}} BULAN LAGI",
    "sourceHash": "e7211b5b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.eyebrow": {
    "text": "KALKULATOR",
    "sourceHash": "b195868d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.title": {
    "text": "Kalkulator Tarikh Pelaksanaan GST InvoiceNow",
    "sourceHash": "386f86e8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.mytaxmailLead": {
    "text": "Ikut surat MyTaxMail daripada IRAS.",
    "sourceHash": "80d5ce30",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.indicative": {
    "text": "Kalkulator ini hanya sebagai panduan. IRAS juga menerbitkan <lnk>hamparan kalkulator</lnk> sendiri.",
    "sourceHash": "717145b9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.q1": {
    "text": "1. Yang mana menggambarkan perniagaan anda?",
    "sourceHash": "a173820f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kind.existing": {
    "text": "Sudah berdaftar GST",
    "sourceHash": "885dfae4",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kind.voluntary": {
    "text": "Mendaftar secara sukarela",
    "sourceHash": "72a133ab",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kind.compulsory": {
    "text": "Mendaftar secara wajib",
    "sourceHash": "46f29b7e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kind.group": {
    "text": "Sebahagian daripada kumpulan GST",
    "sourceHash": "4d8261d7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kind.excluded": {
    "text": "Entiti luar negara, atau berdaftar hanya kerana caj songsang",
    "sourceHash": "29b09196",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kind.notRegistered": {
    "text": "Tidak berdaftar GST",
    "sourceHash": "56e0842f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.q1hint": {
    "text": "Memohon pendaftaran wajib tetapi diluluskan secara sukarela? Pilih pilihan ini (soalan lazim IRAS Q1.6).",
    "sourceHash": "17e96b52",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.q2": {
    "text": "2. Bila anda memohon (atau akan memohon) pendaftaran GST?",
    "sourceHash": "b41b4c75",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.q2hint": {
    "text": "Tarikh permohonan yang dikira, bukan tarikh kelulusan (soalan lazim IRAS Q1.7).",
    "sourceHash": "5ffa4140",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.q3": {
    "text": "3. Adakah syarikat diperbadankan dalam tempoh 6 bulan sebelum permohonan?",
    "sourceHash": "cf03eefe",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.q4": {
    "text": "4. Adakah ia dipindahkan pendaftarannya ke Singapura?",
    "sourceHash": "504df8b1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.qReturns": {
    "text": "{{n}}. Adakah anda mempunyai penyata GST untuk tempoh perakaunan yang berakhir pada 2025?",
    "sourceHash": "9b61dc20",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.returnsYes": {
    "text": "Ya, termasuk penyata sifar",
    "sourceHash": "69f015cf",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.qEnds": {
    "text": "Pada bulan apa tempoh perakaunan anda berakhir?",
    "sourceHash": "a75ee2f9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.ends.mar-jun-sep-dec": {
    "text": "Mac, Jun, Sep, Dis",
    "sourceHash": "898b4c44",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.ends.jan-apr-jul-oct": {
    "text": "Jan, Apr, Jul, Okt",
    "sourceHash": "bbef00f0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.ends.feb-may-aug-nov": {
    "text": "Feb, Mei, Ogo, Nov",
    "sourceHash": "8158f7bd",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.ends.monthly": {
    "text": "Setiap bulan",
    "sourceHash": "cb5eaf92",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.window.mar-jun-sep-dec": {
    "text": "Januari 2025 hingga Disember 2025",
    "sourceHash": "49706a77",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.window.jan-apr-jul-oct": {
    "text": "November 2024 hingga Oktober 2025",
    "sourceHash": "c4fa8141",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.window.feb-may-aug-nov": {
    "text": "Disember 2024 hingga November 2025",
    "sourceHash": "a48f9356",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.window.monthly": {
    "text": "Januari 2025 hingga Disember 2025",
    "sourceHash": "49706a77",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.suppliesFrom": {
    "text": "Bekalan anda dari {{window}}",
    "sourceHash": "26e2926d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.addUp": {
    "text": "Jumlahkan semua penyata untuk tempoh yang berakhir pada 2025 (Kotak 4 ialah jumlahnya). Penyata sifar dikira sebagai S$0.",
    "sourceHash": "0ace1072",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.sr": {
    "text": "Berkadar standard (S$)",
    "sourceHash": "3aade13f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.zr": {
    "text": "Berkadar sifar (S$)",
    "sourceHash": "6d230976",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.ex": {
    "text": "Dikecualikan (S$)",
    "sourceHash": "1f11d064",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.qFull": {
    "text": "Adakah penyata itu meliputi 12 bulan penuh?",
    "sourceHash": "b8a82dfa",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.fullNo": {
    "text": "Tidak, sebahagian tahun",
    "sourceHash": "c1e50250",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.qDays": {
    "text": "Berapa hari yang diliputi?",
    "sourceHash": "c417b49a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.daysPlaceholder": {
    "text": "cth. 61",
    "sourceHash": "d3655bec",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.empty": {
    "text": "Jawab soalan untuk melihat fasa anda. Apa yang anda masukkan tidak meninggalkan pelayar anda.",
    "sourceHash": "cb154492",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kicker.phase": {
    "text": "FASA ANDA · {{until}}",
    "sourceHash": "da4b5e54",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kicker.from-registration": {
    "text": "TERPAKAI SEJAK PENDAFTARAN",
    "sourceHash": "3d0719b6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kicker.iras-will-notify": {
    "text": "IRAS AKAN MEMBERITAHU ANDA",
    "sourceHash": "3ff33fc0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kicker.follow-group": {
    "text": "IKUT KUMPULAN GST ANDA",
    "sourceHash": "5f073b36",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kicker.not-required": {
    "text": "TIDAK DIWAJIBKAN",
    "sourceHash": "37ffb4d7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.date.from-registration": {
    "text": "Sejak pendaftaran",
    "sourceHash": "353e846a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.date.iras-will-notify": {
    "text": "IRAS akan memberitahu anda",
    "sourceHash": "4b3e7862",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.date.follow-group": {
    "text": "Tarikh kumpulan anda",
    "sourceHash": "0a0ee677",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.date.not-required": {
    "text": "Tidak diwajibkan",
    "sourceHash": "457ecb17",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.total": {
    "text": "JUMLAH BEKALAN TAHUNAN",
    "sourceHash": "cde45247",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.equiv": {
    "text": "(SETARA 365 HARI)",
    "sourceHash": "a2f310c9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.nextSteps": {
    "text": "Semak langkah seterusnya",
    "sourceHash": "388d4b07",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.ask": {
    "text": "Tanya IRAS tentang kes saya",
    "sourceHash": "b149fe5e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.disclaimer": {
    "text": "Panduan sahaja. Tarikh dalam notis MyTaxMail IRAS yang terpakai. Sebahagian daripada francais atau kumpulan seumpamanya yang berkongsi ERP dan perlukan lebih masa? IRAS menimbang permohonan lanjutan satu demi satu (soalan lazim Q1.14).",
    "sourceHash": "6a570cea",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.count": {
    "text": "{{count}} SOALAN, BERSUMBER",
    "sourceHash": "2601f760",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.lead": {
    "text": "Jawapan ringkas. Setiap ayat dipautkan kepada dokumen rasmi yang menyatakannya, kebanyakannya <lnk>FAQ for businesses (23 Sep 2026)</lnk> IRAS dan e-Tax Guide.",
    "sourceHash": "7c81d2ae",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.own": {
    "text": "Untuk soalan tentang perniagaan anda sendiri, gunakan <iras>borang pertanyaan IRAS</iras> atau <imda>borang hubungan IMDA</imda>.",
    "sourceHash": "858738e0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grants.imda": {
    "text": "Geran InvoiceNow IMDA",
    "sourceHash": "adb16488",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grants.infographic": {
    "text": "Infografik",
    "sourceHash": "23e80f0b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grants.footnote": {
    "text": "Terma geran daripada <grants>{{grantsLabel}}</grants>. Semak kelayakan serta terma dan syarat dengan IMDA sebelum anda melanggan atau memulakan projek.",
    "sourceHash": "c2d31e02",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grants.answerTitle": {
    "text": "Apakah geran InvoiceNow yang ada?",
    "sourceHash": "b8ff433f",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grants.faqLink": {
    "text": "Soalan lazim geran IMDA",
    "sourceHash": "9ab3c874",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grants.faqHeading": {
    "text": "SOALAN BERKAITAN",
    "sourceHash": "2b9de2c5",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.heading": {
    "text": "PAKEJ PERCUMA",
    "sourceHash": "3c70769f",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.grantsTitle": {
    "text": "Geran InvoiceNow",
    "sourceHash": "4b5a8bf7",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.grantsBody": {
    "text": "Geran Peralihan IMDA dan Geran Queen Bee untuk penyelesaian berbayar atau menyambungkan ERP anda sendiri.",
    "sourceHash": "84913ce3",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.grantsLink": {
    "text": "Lihat geran",
    "sourceHash": "d8b3cd8e",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.checkTitle": {
    "text": "Adakah perisian perakaunan saya InvoiceNow-Ready?",
    "sourceHash": "57c2b2d7",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.checkLead": {
    "text": "Beginilah pakej popular disenaraikan. Senarai ini kerap berubah, jadi sahkan dengan versi terkini dan dengan penyedia anda.",
    "sourceHash": "6f4f1b0b",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.colSoftware": {
    "text": "Perisian",
    "sourceHash": "c9f3f4b0",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.colStatus": {
    "text": "Dalam senarai IMDA?",
    "sourceHash": "386c1714",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.listed.provider": {
    "text": "Ya, disenaraikan untuk <en>{{provider}}</en>",
    "sourceHash": "23635794",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.listed.partners": {
    "text": "Ya, melalui beberapa rakan pelaksanaan yang disenaraikan",
    "sourceHash": "1b18849f",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.listed.no": {
    "text": "Tiada dalam senarai",
    "sourceHash": "31e73b8c",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.notListed": {
    "text": "Tiada dalam senarai?",
    "sourceHash": "4202fac9",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.footnote": {
    "text": "Pakej percuma daripada <foc>{{focLabel}}</foc>. Semak terma dan syarat dengan IMDA dan penyedia sebelum anda melanggan.",
    "sourceHash": "f13bab98",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "vendor.title": {
    "text": "Mencari penyedia penyelesaian InvoiceNow-Ready atau penyedia Access Point",
    "sourceHash": "0f89f1c0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "vendor.irsp": {
    "text": "Senarai penyedia penyelesaian InvoiceNow-Ready",
    "sourceHash": "3dd2d602",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "vendor.ap": {
    "text": "Senarai Access Point",
    "sourceHash": "f269f97f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "vendor.foc": {
    "text": "Senarai pakej percuma (FOC)",
    "sourceHash": "ddc29fb7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "vendor.callback": {
    "text": "Minta penyedia pakej percuma menelefon",
    "sourceHash": "8b5a108e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "vendor.allow": {
    "text": "PERUNTUKKAN",
    "sourceHash": "40a195d2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "vendor.months": {
    "text": "<from/>–<to/> bulan",
    "sourceHash": "2c742238",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "vendor.note": {
    "text": "untuk menyambungkan sistem perusahaan dalaman kepada IRAS, kata IRAS",
    "sourceHash": "f8c89612",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "how.eyebrow": {
    "text": "BAGAIMANA INVOIS BERGERAK",
    "sourceHash": "7e3a567e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "how.title": {
    "text": "Bagaimana invois<br/><accent>bergerak</accent>",
    "sourceHash": "1e14d5a4",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "how.lead": {
    "text": "InvoiceNow menghantar invois antara perniagaan melalui Access Point (titik akses), dan melaporkan data invois kepada IRAS. Cara ia bergerak bergantung pada sama ada anda menghantar atau menerima, dan sama ada perniagaan satu lagi juga dalam InvoiceNow.",
    "sourceHash": "3e2cc109",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "need.eyebrow": {
    "text": "APA YANG ANDA PERLUKAN",
    "sourceHash": "f56c0f90",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "need.peppolTitle": {
    "text": "Peppol ID",
    "sourceHash": "e8ef1f25",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "need.peppolBody": {
    "text": "Alamat unik perniagaan anda dalam rangkaian InvoiceNow. Minta penyedia IRSP atau Access Point anda mendaftarkan perniagaan anda dalam SG Peppol Directory menggunakan UEN (nombor pengenalan entiti) anda.",
    "sourceHash": "c81f93ed",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "need.irspTitle": {
    "text": "Penyedia penyelesaian InvoiceNow-Ready (IRSP) atau Access Point (AP)",
    "sourceHash": "7a0d12d1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "need.irspBody": {
    "text": "IRSP menawarkan perisian perakaunan atau kewangan yang sudah disambung ke rangkaian melalui Access Point (titik akses) bertauliah. Jika anda menggunakan sistem dalaman sendiri, anda menyambungkannya melalui penyedia Access Point yang ditauliahkan IMDA.",
    "sourceHash": "a97d60a9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "need.find": {
    "text": "Cari IRSP atau Access Point",
    "sourceHash": "d57d2f54",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.label": {
    "text": "CARI MENGIKUT NAMA SYARIKAT ATAU UEN",
    "sourceHash": "281e0185",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.placeholder": {
    "text": "Nama syarikat atau UEN, cth. 201538812W",
    "sourceHash": "43c52a01",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.aria": {
    "text": "Nama syarikat atau UEN",
    "sourceHash": "f2805234",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.check": {
    "text": "Semak Peppol ID",
    "sourceHash": "6e66803a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.searching": {
    "text": "Mencari…",
    "sourceHash": "2713de23",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.invalid": {
    "text": "Taip sekurang-kurangnya 2 huruf nama syarikat anda, atau UEN anda.",
    "sourceHash": "cd611560",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.unreachable": {
    "text": "Tidak dapat menghubungi Peppol Directory sekarang. Cuba lagi sebentar nanti.",
    "sourceHash": "55d71974",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.found": {
    "text": "<b>Ditemui:</b> {{name}} <id>{{peppolId}}</id>. Tugas anda seterusnya ialah mengesahkan ia disambung kepada penyedia yang anda rancang untuk gunakan.",
    "sourceHash": "0ee87f4c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.registered": {
    "text": "Berdaftar",
    "sourceHash": "cdc6d0e1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.notFound": {
    "text": "Tidak ditemui dalam Peppol Directory. Ini perkara biasa jika anda belum menyertai. Penyedia IRSP atau Access Point anda akan mendaftarkannya untuk anda. <lnk>Cari penyedia</lnk>",
    "sourceHash": "d932ee7a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.notFoundName": {
    "text": "Tiada padanan untuk nama itu. Cuba nama berdaftar penuh atau UEN anda. Belum berdaftar? Penyedia IRSP atau Access Point anda akan mendaftarkannya untuk anda. <lnk>Cari penyedia</lnk>",
    "sourceHash": "9b1ed20e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.matches": {
    "text": "Padanan dalam Peppol Directory: {{total}}. Jika perniagaan anda tersenarai, ia sudah ada Peppol ID. Tugas anda seterusnya ialah mengesahkan ia disambung kepada penyedia yang anda rancang untuk gunakan.",
    "sourceHash": "e1ddae9e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.more": {
    "text": "Menunjukkan {{shown}} daripada {{total}}. Taip lebih banyak nama, atau UEN anda, untuk mengecilkan carian.",
    "sourceHash": "57697379",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.iAm": {
    "text": "SAYA IALAH…",
    "sourceHash": "cc41e59d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.supplier": {
    "text": "Pembekal, menghantar invois",
    "sourceHash": "0d5706bb",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.customer": {
    "text": "Pelanggan, menerima invois",
    "sourceHash": "95463d1f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.who": {
    "text": "SIAPA DALAM INVOICENOW?",
    "sourceHash": "92863170",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.both": {
    "text": "Kedua-dua kami",
    "sourceHash": "63fcdba9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.me": {
    "text": "Saya sahaja",
    "sourceHash": "d9d30f77",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.lane.iras": {
    "text": "IRAS",
    "sourceHash": "7be84b1e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.lane.network": {
    "text": "RANGKAIAN INVOICENOW",
    "sourceHash": "5c121afe",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.lane.businesses": {
    "text": "PERNIAGAAN ANDA",
    "sourceHash": "76356c38",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.offline": {
    "text": "PDF · E-MEL · KERTAS",
    "sourceHash": "11632b2b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.node.supplier": {
    "text": "Pembekal",
    "sourceHash": "b167f229",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.node.customer": {
    "text": "Pelanggan",
    "sourceHash": "09f3c039",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.node.iras": {
    "text": "IRAS",
    "sourceHash": "7be84b1e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.node.yours": {
    "text": "Penyelesaian anda",
    "sourceHash": "cc62bba5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.node.theirs": {
    "text": "Penyelesaian mereka",
    "sourceHash": "39bcf11e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.sub.notOn": {
    "text": "TIADA DALAM INVOICENOW",
    "sourceHash": "3afb6658",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.sub.notNetwork": {
    "text": "TIADA DALAM RANGKAIAN",
    "sourceHash": "5a6334b5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.sub.tax": {
    "text": "PIHAK BERKUASA CUKAI",
    "sourceHash": "af6c504f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.sub.ap": {
    "text": "ACCESS POINT",
    "sourceHash": "59953bcd",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.you": {
    "text": "ANDA",
    "sourceHash": "956decfc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.play": {
    "text": "Mainkan animasi",
    "sourceHash": "874eb831",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.pause": {
    "text": "Jeda animasi",
    "sourceHash": "52d63d7f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.stepAria": {
    "text": "Langkah {{n}}: {{title}}",
    "sourceHash": "d1fceddf",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.legend.invoice": {
    "text": "INVOIS",
    "sourceHash": "cf85b330",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.legend.data": {
    "text": "SALINAN KEPADA IRAS",
    "sourceHash": "4bdb87b0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.legend.offline": {
    "text": "SALINAN LUAR RANGKAIAN",
    "sourceHash": "7a61372e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.tag.parallel": {
    "text": "SERENTAK",
    "sourceHash": "a39f2315",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.tag.offNetwork": {
    "text": "LUAR RANGKAIAN",
    "sourceHash": "29b6c97c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.toPartner": {
    "text": "INVOIS → RAKAN NIAGA ANDA",
    "sourceHash": "a7f05d67",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.toIras": {
    "text": "DATA INVOIS → IRAS",
    "sourceHash": "b82901d9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.headline": {
    "text": "Anda menghantar, dan pelanggan anda juga dalam InvoiceNow",
    "sourceHash": "54087a5e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.toBusiness": {
    "text": "Melalui rangkaian InvoiceNow: Access Point anda memajukan invois Peppol ke Access Point pelanggan anda sebagai data berstruktur.",
    "sourceHash": "c4869be7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.toIras": {
    "text": "Penghantaran Type 1A: sebaik sahaja invois dihantar ke Access Point pelanggan anda, salinan invois Peppol pergi kepada IRAS secara automatik. Pelanggan anda kemudian menghantar salinan mereka sendiri (Type 1B).",
    "sourceHash": "2a8da6a8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.0.title": {
    "text": "Keluarkan",
    "sourceHash": "600895e0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.0.text": {
    "text": "Anda mengeluarkan invois Peppol dalam penyelesaian InvoiceNow-Ready anda dan menghantarnya ke Access Point anda. Penyelesaian yang ada semakan pengesahan GST akan memberi amaran jika GST dikenakan secara salah.",
    "sourceHash": "e1466257",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.1.title": {
    "text": "Hantar dan salin kepada IRAS",
    "sourceHash": "ce947cc3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.1.text": {
    "text": "Access Point anda memajukan invois ke Access Point pelanggan anda. Sebaik sahaja dihantar, salinan invois Peppol pergi kepada IRAS secara automatik.",
    "sourceHash": "1cbd8bb4",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.2.title": {
    "text": "Serahkan",
    "sourceHash": "4955b9ae",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.2.text": {
    "text": "Access Point pelanggan anda memajukan invois kepada pelanggan anda.",
    "sourceHash": "feb817ca",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.3.title": {
    "text": "Pelanggan juga menghantar",
    "sourceHash": "0dc2f06c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.3.text": {
    "text": "Pelanggan anda menerima invois dalam penyelesaian mereka dan merekodkan butiran pembelian GST mereka. Access Point mereka menghantar salinan Solution-extracted pembelian itu kepada IRAS.",
    "sourceHash": "11484894",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.me.headline": {
    "text": "Anda menghantar, tetapi pelanggan anda tiada dalam InvoiceNow",
    "sourceHash": "76ea01b7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.me.toBusiness": {
    "text": "Di luar rangkaian: anda memberi pelanggan invois kertas atau PDF, seperti hari ini.",
    "sourceHash": "b3e17818",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.me.toIras": {
    "text": "Penghantaran Type 2: penyelesaian anda mengekstrak invois dan Access Point anda menghantarnya kepada IRAS. Ini juga terpakai apabila bekalan diagregat, seperti jualan POS atau invois cukai ringkas.",
    "sourceHash": "6490082d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.me.0.title": {
    "text": "Keluarkan dan rekod",
    "sourceHash": "e9ec0b9a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.me.0.text": {
    "text": "Anda memberi pelanggan invois kertas atau PDF dan merekodkan jualan dalam penyelesaian InvoiceNow-Ready anda. Ia tidak bergerak dalam rangkaian.",
    "sourceHash": "f0271b4a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.me.1.title": {
    "text": "Ekstrak dan lapor",
    "sourceHash": "abfdc6cf",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.me.1.text": {
    "text": "Penyelesaian anda menghantar invois Solution-extracted ke Access Point anda, yang memancarkannya kepada IRAS.",
    "sourceHash": "03c42d61",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.headline": {
    "text": "Anda menerima, dan pembekal anda juga dalam InvoiceNow",
    "sourceHash": "f5fe09d5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.toBusiness": {
    "text": "Melalui rangkaian InvoiceNow: Access Point pembekal anda memajukan invois Peppol ke Access Point anda sebagai data berstruktur.",
    "sourceHash": "d7e9df9a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.toIras": {
    "text": "Penghantaran Type 1B: selepas anda menerima invois, salinan Solution-extracted pembelian anda pergi kepada IRAS melalui Access Point anda. Salinan Peppol pembekal anda (Type 1A) dihantar secara berasingan.",
    "sourceHash": "b3a58971",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.0.title": {
    "text": "Keluarkan",
    "sourceHash": "600895e0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.0.text": {
    "text": "Pembekal anda mengeluarkan invois Peppol dalam penyelesaian InvoiceNow-Ready mereka.",
    "sourceHash": "c8d431ad",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.1.title": {
    "text": "Hantar",
    "sourceHash": "f28e14cf",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.1.text": {
    "text": "Access Point mereka memajukannya ke Access Point anda. Sebaik sahaja dihantar, salinan invois Peppol pergi kepada IRAS dari pihak mereka.",
    "sourceHash": "cda781be",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.2.title": {
    "text": "Terima",
    "sourceHash": "2e823442",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.2.text": {
    "text": "Access Point anda memajukan invois kepada anda sebagai data, tanpa perlu menaip semula.",
    "sourceHash": "32aaf536",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.3.title": {
    "text": "Terima dan lapor",
    "sourceHash": "242bc2b6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.3.text": {
    "text": "Anda mengesahkan dan menerimanya dalam penyelesaian anda, memilih kategori GST, jumlah pembelian dan cukai input untuk dituntut. Salinan Solution-extracted pergi kepada IRAS melalui Access Point anda.",
    "sourceHash": "06b6a288",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.me.headline": {
    "text": "Anda menerima, tetapi pembekal anda tiada dalam InvoiceNow",
    "sourceHash": "6cbebde0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.me.toBusiness": {
    "text": "Di luar rangkaian: invois sampai kepada anda sebagai PDF atau kertas, seperti hari ini.",
    "sourceHash": "58c597f9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.me.toIras": {
    "text": "Penghantaran Type 3: penyelesaian anda mengekstrak pembelian dan Access Point anda menghantarnya kepada IRAS. Ini juga terpakai kepada pembelian agregat seperti wang runcit.",
    "sourceHash": "8de06b13",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.me.0.title": {
    "text": "Terima",
    "sourceHash": "2e823442",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.me.0.text": {
    "text": "Pembekal anda menghantar invois kertas atau PDF kepada anda. Ia tidak bergerak dalam rangkaian.",
    "sourceHash": "2391b008",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.me.1.title": {
    "text": "Rekod",
    "sourceHash": "9f4565ec",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.me.1.text": {
    "text": "Anda merekodkan pembelian dalam penyelesaian InvoiceNow-Ready anda. Penyelesaian yang ada semakan pengesahan GST akan memberi amaran jika GST dikenakan secara salah.",
    "sourceHash": "97271995",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.me.2.title": {
    "text": "Ekstrak dan lapor",
    "sourceHash": "abfdc6cf",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.me.2.text": {
    "text": "Penyelesaian anda menghantar invois Solution-extracted ke Access Point anda, yang memancarkannya kepada IRAS.",
    "sourceHash": "739a8ecb",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.eyebrow": {
    "text": "BANTU SAYA MEMILIH",
    "sourceHash": "6024c28d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.title": {
    "text": "Pilihan mana yang sesuai untuk saya?",
    "sourceHash": "5ee3747e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.q3": {
    "text": "1. Berapa banyak invois yang anda keluarkan dan terima?",
    "sourceHash": "e86275b7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.vol.low": {
    "text": "Rendah",
    "sourceHash": "b1dd9521",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.vol.lowSub": {
    "text": "Beberapa sebulan",
    "sourceHash": "581a6e39",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.vol.medium": {
    "text": "Sederhana",
    "sourceHash": "09be5f96",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.vol.mediumSub": {
    "text": "Berpuluh-puluh sebulan",
    "sourceHash": "a096dc27",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.vol.high": {
    "text": "Tinggi",
    "sourceHash": "be0a061d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.vol.highSub": {
    "text": "Beratus-ratus atau lebih",
    "sourceHash": "2ec41bc2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.q4": {
    "text": "2. Apa yang anda gunakan untuk invois sekarang?",
    "sourceHash": "3c5f9fa5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.tool.manual": {
    "text": "Manual",
    "sourceHash": "f819f303",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.tool.manualSub": {
    "text": "Word, Excel, PDF",
    "sourceHash": "b775770f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.tool.software": {
    "text": "Perisian perakaunan",
    "sourceHash": "5e9c3af1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.tool.softwareSub": {
    "text": "Pakej sedia ada",
    "sourceHash": "fa76f995",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.tool.custom": {
    "text": "ERP atau sistem dalaman",
    "sourceHash": "670dde48",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.tool.customSub": {
    "text": "Khas atau bersepadu",
    "sourceHash": "4263e83c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.empty": {
    "text": "Jawab dua soalan dan kami akan mencadangkan jenis penyelesaian untuk dilihat dahulu.",
    "sourceHash": "30e1ee9e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.disclaimer": {
    "text": "Panduan umum sahaja. Semak kelayakan, harga dan ketersediaan dengan IMDA, IRAS dan penyedia sebelum anda membuat keputusan.",
    "sourceHash": "d6a0edc2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.route.kicker": {
    "text": "LALUAN YANG DICADANGKAN",
    "sourceHash": "ffe36e89",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.FOC.name": {
    "text": "Penyelesaian percuma (FOC)",
    "sourceHash": "361ea5f3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.FOC.what": {
    "text": "IMDA menyenaraikan pakej InvoiceNow percuma untuk perniagaan berdaftar GST. Ia mungkin sesuai untuk perniagaan yang mengeluarkan sedikit invois dan menggunakan hamparan, Word atau PDF hari ini.",
    "sourceHash": "31792265",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.FOC.0": {
    "text": "Pilih pakej daripada senarai pakej percuma IMDA. Tarikh mula dan tamat berbeza mengikut penyedia, jadi semak tarikh untuk pakej yang anda pilih.",
    "sourceHash": "0330ed6e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.FOC.1": {
    "text": "Daftar, kemudian daftarkan Peppol ID anda (ID berasaskan UEN anda) melalui penyedia.",
    "sourceHash": "0a9e08c9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.FOC.2": {
    "text": "Hantar invois ujian dan sahkan data sampai kepada IRAS sebelum tarikh mula anda.",
    "sourceHash": "cc0a2a77",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.IRSP.name": {
    "text": "Penyedia penyelesaian InvoiceNow-Ready (IRSP)",
    "sourceHash": "8503d344",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.IRSP.what": {
    "text": "Perisian perakaunan atau invois dengan sambungan Access Point terbina dalam, jadi invois dan penghantaran data kepada IRAS dibuat dari alat yang sudah anda gunakan.",
    "sourceHash": "158cc89a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.IRSP.0": {
    "text": "Semak senarai penyedia penyelesaian InvoiceNow-Ready IMDA. Jika perisian semasa anda tersenarai, tanya vendor cara menghidupkan InvoiceNow.",
    "sourceHash": "8f638a12",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.IRSP.1": {
    "text": "Jika tidak, senarai pendekkan penyedia tersenarai yang sesuai dengan jumlah invois dan bajet anda.",
    "sourceHash": "c256493e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.IRSP.2": {
    "text": "Minta penyedia mendaftarkan Peppol ID anda, kemudian uji penghantaran sebelum tarikh mula anda.",
    "sourceHash": "b2ccef6b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.AP.name": {
    "text": "Penyedia Peppol Access Point (AP)",
    "sourceHash": "c8495985",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.AP.what": {
    "text": "Penyedia yang menyambungkan sistem anda sendiri (ERP atau dalaman) ke rangkaian. Paling sesuai apabila invois dijana oleh perisian yang anda kawal atau dalam jumlah yang tinggi.",
    "sourceHash": "1263b849",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.AP.0": {
    "text": "Senaraikan sistem yang menjana dan menerima invois anda, dan siapa yang menyelenggara integrasi.",
    "sourceHash": "be87739d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.AP.1": {
    "text": "Senarai pendekkan penyedia daripada senarai penyedia Access Point IMDA dan sahkan mereka menyokong format eksport sistem anda.",
    "sourceHash": "f461faa6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.AP.2": {
    "text": "Daftarkan Peppol ID anda melalui Access Point, kemudian jalankan ujian hujung ke hujung termasuk penghantaran data kepada IRAS.",
    "sourceHash": "016ac0c9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.link.iras": {
    "text": "Halaman keperluan IRAS",
    "sourceHash": "1068e5ec",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.link.foc": {
    "text": "Senarai pakej percuma",
    "sourceHash": "9ee3fb61",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.link.ap": {
    "text": "Senarai Access Point",
    "sourceHash": "f269f97f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.link.irsp": {
    "text": "Senarai IRSP",
    "sourceHash": "c2af4eb3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.eyebrow": {
    "text": "PAUTAN BERGUNA",
    "sourceHash": "e36a7c96",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.title": {
    "text": "Setiap pautan, <accent>diterangkan</accent>",
    "sourceHash": "401b26c9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.eyebrow": {
    "text": "TENTANG",
    "sourceHash": "4475af1e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.title": {
    "text": "Bebas, <accent>tidak rasmi</accent>, bersumber",
    "sourceHash": "3a1f5b49",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.who.title": {
    "text": "Siapa yang mengendalikan laman ini",
    "sourceHash": "c75f38fc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.who.body": {
    "text": "InvoiceNow Hub ialah laman web bebas. Ia tidak dikendalikan, disokong atau bergabung dengan Lembaga Hasil Dalam Negeri Singapura (IRAS) atau Penguasa Pembangunan Media Infokom (IMDA).",
    "sourceHash": "6d510d85",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.why.title": {
    "text": "Mengapa ia wujud",
    "sourceHash": "9f7701ba",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.why.body": {
    "text": "Maklumat rasmi tentang GST InvoiceNow Requirement tersebar di beberapa halaman web dan PDF IRAS dan IMDA. Laman ini mengumpulkannya di satu tempat, dalam bahasa mudah, dan memautkan setiap kenyataan kembali kepada dokumen rasmi yang menyatakannya.",
    "sourceHash": "e283fb73",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.unofficial.title": {
    "text": "Ia tidak rasmi",
    "sourceHash": "efb0b4c6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.unofficial.body": {
    "text": "Tiada apa-apa di sini ialah nasihat undang-undang atau cukai, dan ia tidak menggantikan tarikh pelaksanaan yang dihantar IRAS kepada anda melalui MyTaxMail. Jika apa-apa di sini berbeza daripada IRAS atau IMDA, sumber rasmi yang betul.",
    "sourceHash": "83ce30b0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.unofficial.channels": {
    "text": "Untuk apa-apa tentang perniagaan anda sendiri, gunakan saluran rasmi: <iras>IRAS GST InvoiceNow queries form</iras> atau <imda>IMDA InvoiceNow contact form</imda>.",
    "sourceHash": "e46d2c5c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.translations.title": {
    "text": "Terjemahan",
    "sourceHash": "5901bcad",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.translations.body": {
    "text": "Versi bahasa Cina, Melayu dan Tamil ialah terjemahan tidak rasmi teks bahasa Inggeris. Versi bahasa Inggeris diguna pakai. Terjemahan yang belum disemak oleh penutur asli ditandakan sebagai draf di bahagian atas setiap halaman; jika teks bahasa Inggeris berubah, teks bahasa Inggeris dipaparkan sehingga terjemahan dikemas kini.",
    "sourceHash": "6c37be80",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.check.title": {
    "text": "Bagaimana kandungan disemak",
    "sourceHash": "10eb8ce1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.check.body": {
    "text": "Setiap tarikh, ambang, jumlah, jawapan soalan lazim dan pautan disimpan dalam satu fail data bersama URL sumber rasmi, nombor soalan atau perenggan yang tepat, dan tarikh ia kali terakhir disemak. Halaman, data soalan lazim untuk enjin carian dan <txt>versi teks biasa</txt> semuanya dijana daripada fail itu, jadi ia tidak boleh bercanggah. Semakan automatik mengesahkan setiap pautan sumber masih berfungsi dan menandakan apa-apa yang tidak disemak semula dalam 30 hari lepas.",
    "sourceHash": "94cb7fe2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.check.last": {
    "text": "Kandungan kali terakhir disemak berbanding sumber rasmi pada <b>{{date}}</b>. Inilah satu-satunya sumber yang digunakan oleh laman ini:",
    "sourceHash": "9cbd5c33",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.check.checked": {
    "text": "disemak {{date}}",
    "sourceHash": "c8a58a32",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.check.changelog": {
    "text": "Setiap perubahan kandungan disenaraikan bersama tarikhnya dalam <lnk>log perubahan</lnk>.",
    "sourceHash": "5fa09f15",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.privacy.title": {
    "text": "Privasi",
    "sourceHash": "ebfa87e7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.privacy.lead": {
    "text": "Laman ini tidak meminta nama, e-mel atau apa-apa akaun anda. Kodnya sendiri tidak memuatkan skrip pengiklanan.",
    "sourceHash": "6e9962e9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.privacy.checklist": {
    "text": "<b>Senarai semak:</b> “Apa yang perlu dibuat sekarang” menyimpan berapa langkah yang telah anda tanda (satu nombor) dalam storan setempat pelayar anda, supaya ia masih ada pada lawatan seterusnya. Ia tidak pernah meninggalkan peranti anda. Gunakan “Set semula senarai semak” atau padam data laman ini untuk membuangnya.",
    "sourceHash": "05dc1042",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.privacy.display": {
    "text": "<b>Tetapan paparan:</b> sama ada anda telah melihat animasi pembukaan dan sama ada anda menutup pintasan senarai semak disimpan dalam storan sesi, yang dipadam oleh pelayar apabila anda menutup tab.",
    "sourceHash": "a8983f5e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.privacy.language": {
    "text": "<b>Bahasa:</b> jika anda memilih bahasa dengan penukar bahasa, satu kuki kecil mengingati pilihan anda supaya laman ini tidak mengalihkan anda. Ia hanya mengandungi kod bahasa.",
    "sourceHash": "c1e811cb",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.privacy.calc": {
    "text": "<b>Kalkulator tarikh dan “Pilihan mana yang sesuai untuk saya?”:</b> berjalan sepenuhnya dalam pelayar anda dan tidak menyimpan apa-apa.",
    "sourceHash": "20c08d6b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.privacy.peppol": {
    "text": "<b>Semakan Peppol ID:</b> Nama syarikat atau UEN yang anda taip dihantar ke Peppol Directory awam (directory.peppol.eu) untuk dicari. Tiada apa-apa lagi yang dihantar, dan kod laman ini tidak menyimpannya.",
    "sourceHash": "69907a85",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.privacy.fonts": {
    "text": "<b>Fon:</b> disediakan oleh laman ini, bukan oleh pihak ketiga.",
    "sourceHash": "14122bb3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.privacy.analytics": {
    "text": "<b>Analitik:</b> Cloudflare Web Analytics kini dihidupkan oleh hos kami, Cloudflare. Ia menambah skrip dari static.cloudflareinsights.com yang menghantar data paparan halaman kepada Cloudflare. Ia bukan sebahagian daripada kod laman ini; nota ini akan dikemas kini jika ia dimatikan.",
    "sourceHash": "b75fb1d9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "changelog.eyebrow": {
    "text": "LOG PERUBAHAN",
    "sourceHash": "8628b339",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "changelog.title": {
    "text": "Apa yang berubah, <accent>dan bila</accent>",
    "sourceHash": "8357f12f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "changelog.lead": {
    "text": "Setiap perubahan kandungan di laman ini, yang terbaharu dahulu. Fakta disemak berbanding sumber rasmi IRAS dan IMDA yang disenaraikan di <lnk>halaman Tentang</lnk>.",
    "sourceHash": "9335307d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "notfound.title": {
    "text": "Halaman <accent>tidak ditemui</accent>",
    "sourceHash": "abb2b9fa",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "notfound.body": {
    "text": "Tiada halaman di alamat ini. Ia mungkin telah berpindah semasa laman ini dipecahkan kepada halaman topik.",
    "sourceHash": "1786edf3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "notfound.home": {
    "text": "Pergi ke halaman utama",
    "sourceHash": "6fe7cf79",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "notfound.links": {
    "text": "Pautan berguna",
    "sourceHash": "237d6316",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  }
}
